<template>
  <div class="view pa24">
    选择状态：
    <el-radio
      class="mr10"
      style="margin: 0"
      v-for="(item, index) in radioArr"
      :key="index"
      v-model="radioValue"
      :label="item.value"
      border
      >{{ item.text }}</el-radio
    >
    <el-button type="primary" @click="queryPageDemandSquare">搜索</el-button>
    <div style="float: right">
      <el-button type="primary" @click="batchTejectAuditing"
        >批量驳回</el-button
      >
      <el-button type="primary" class="ml20" @click="batchPassAuditing"
        >批量通过</el-button
      >
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      clearName = 'demandProtuctsCheck'
      itemKey='auditing'
      :total="total"
    >
      <template v-slot:table>
        <el-table-column type="selection" width="55" />
        <el-table-column
          type="index"
          align="center"
          label="序号"
          show-overflow-tooltip
        />
        <el-table-column prop="createdTime" align="center" label="创建时间" />
        <el-table-column prop="companyName" align="center" label="公司名称" show-overflow-tooltip />
        <el-table-column prop="name" align="center" label="发布人" show-overflow-tooltip />
        <el-table-column prop="description" align="center" label="内容" show-overflow-tooltip/>
        <el-table-column align="center" prop="images" label="图片">
          <template slot-scope="scope">
            <el-image
              style="width: 36px; height: 36px"
              :src="scope.row.imagesList[0]"
              :preview-src-list="scope.row.imagesList"
            >
            </el-image>
            <span>x{{ scope.row.imagesList.length }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="note" label="备注" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="auditing" label="状态">
          <!--                    审核状态 0待审核 1 审核通过 2 审核不通过-->
          <template slot-scope="scope">
            {{
              scope.row.auditing == 0
                ? "待审核"
                : scope.row.auditing == 1
                ? "已通过"
                : scope.row.auditing == 2 && "已驳回"
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="170">
          <template slot-scope="scope">
            <el-button
              @click="rejectAuditing(scope.row)"
              type="text"
              size="small"
              style="color: #fd634e"
              v-if="scope.row.auditing == 0"
            >
              {{ scope.row.auditing == 0 ? "驳回" : "---" }}
            </el-button>
            <customPopconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              v-if="scope.row.auditing == 0"
              @confirm="reviewDemandSquareStatus(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              title="确认通过审核吗？"
            >
              <el-button slot="reference" type="text" class="ml10" size="small">
                {{ scope.row.auditing == 0 && "通过" }}
              </el-button>
            </customPopconfirm>
            <customPopconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              v-if="scope.row.auditing == 1"
              @confirm="offDemandSquare(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              title="确认删除吗？"
            >
              <el-button type="text" slot="reference" size="small">
                删除
              </el-button>
            </customPopconfirm>
            <el-button type="text" size="small" v-if="scope.row.auditing == 2">
              {{ scope.row.reasonNote }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      title="驳回原因"
      width="400px"
      ref="form"
      :modal-append-to-body="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" type="textarea" rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="btncss" @click="submitData()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import {
  queryPageDemandSquare,
  reviewDemandSquareStatus,
  updateDemandSquareStatus,
  batchReviewDemandSquareStatus,
} from "@/api/addedServices";
export default {
  data() {
    return {
      radioValue: "",
      radioArr: [
        { text: "全部", value: "" },
        { text: "待审核", value: "0" },
        { text: "已通过", value: "1" },
        { text: "已驳回", value: "2" },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      dialogFormVisible: false,
      form: {},
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入驳回原因", trigger: "blur" }],
      },
      multipleSelection: [],
      isMultipleSelection: false,
    };
  },
  components: {
    commonTable,
    customPopconfirm
  },
  created() {
    this.queryPageDemandSquare();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryPageDemandSquare();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryPageDemandSquare();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async queryPageDemandSquare() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        auditing: this.radioValue,
        isDraft: false,
      };
      try {
        this.loading = true;
        const result = await queryPageDemandSquare(data);
        this.loading = false;
        console.log(result);
        const {
          pageInfo: { total, list },
        } = result?.data;
        list.forEach((item) => {
          item.imagesList = JSON.parse(item.images);
        });
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        this.tableData = [];
        console.log(error);
      }
    },
    /**@method 通过审核 */
    async reviewDemandSquareStatus(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.auditing = 1;
      await reviewDemandSquareStatus(data);
      await this.queryPageDemandSquare();
    },
    /**@method 驳回 */
    rejectAuditing(row) {
      this.dialogFormVisible = true;
      this.form = row;
    },
   async submitData() {
      if (this.isMultipleSelection) {
        let data = {
          squareIds: this.multipleSelection.map((item) => item.squareId),
          auditing: 2,
          reasonNote: this.ruleForm.name,
          isPublic: 0,
          isDraft: true,
        };
        await batchReviewDemandSquareStatus(data);
        this.dialogFormVisible = false;
        this.queryPageDemandSquare();
      } else {
        let data = JSON.parse(JSON.stringify(this.form));
        data.auditing = 2;
        data.reasonNote = this.ruleForm.name;
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            try {
              await reviewDemandSquareStatus(data);
              this.dialogFormVisible = false;
              await this.queryPageDemandSquare();
            } catch (error) {
              console.log(error);
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    /**@method 删除 */
    async offDemandSquare(row) {
      let data = JSON.parse(JSON.stringify(row));
      data.status = 0;
      data.isDraft = true;
      try {
        await updateDemandSquareStatus(data);
        this.queryPageDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 批量通过 */
    async batchPassAuditing() {
      if (this.multipleSelection.length != 0) {
        let data = {
          auditing: 1,
          squareIds: this.multipleSelection.map((item) => item.squareId),
        };
        await batchReviewDemandSquareStatus(data);
        this.queryPageDemandSquare();
      } else {
        this.$message({
          message: "请选择需求",
          type: "warning",
        });
      }
    },
    /**@method 批量驳回 */
    batchTejectAuditing() {
      if (this.multipleSelection.length != 0) {
        this.isMultipleSelection = true;
        this.dialogFormVisible = true;
      } else {
        this.$message({
          message: "请选择需求",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>